import React from "react";
import { IntercomProvider } from "react-use-intercom";
export const ChatProvider = ({ props, children }) => {
  return (
    <IntercomProvider appId={process.env.REACT_APP_INTERCOM_CHAT_ID}>
      {children}
    </IntercomProvider>
  );
};
